import { Nillable } from '@web/utils';
import { AdminBoxSaleApproveStatusOrders } from './admin-box-sale-approve-status-orders';

export class AdminBoxSaleApproveStatus {
  public constructor(
    private readonly data: {
      errorMessage?: Nillable<string>;
      isAvailable: boolean;
      orders?: Nillable<AdminBoxSaleApproveStatusOrders>;
      questionnairesWillBeGenerated: boolean;
    },
  ) {}

  public get isAvailable(): boolean {
    return this.data.isAvailable;
  }

  public get errorMessage(): Nillable<string> {
    return this.data.errorMessage;
  }

  public get questionnairesWillBeGenerated(): boolean {
    return this.data.questionnairesWillBeGenerated;
  }

  public get orders(): Nillable<AdminBoxSaleApproveStatusOrders> {
    return this.data.orders;
  }
}
